/**
 * ppid(webid) をセットする関数
 */
export const setPpid = async (gaTargetId, gaOptions) => {
	let webid;
	const currentWebId = (String(document.cookie).match(/web_id=(.+?)(;|$)/) ||
		[])[1];

	const webidUrl = new URL("https://weathernews.jp/api/webid");
	if (currentWebId) {
		webid = currentWebId;
		webidUrl.searchParams.set("webid", webid);
		fetch(webidUrl);
	} else {
		try {
			const { uuid } = await fetch(webidUrl).then((res) => res.json());
			if (uuid) {
				webid = uuid;
			}
		} catch (e) {
			console.error(e);
		}
	}

	if (webid) {
		googletag.cmd.push(() => {
			googletag.pubads().setPublisherProvidedId(webid);
		});
		if (typeof gtag !== 'undefined') {
			gtag('set', 'user_id', webid);
		}
	}
};
